import { SEAT_TYPES } from '../../../../pages/Hall/components/HallSeating/components/GridSeats/constants'
import { getSeatType } from '../../../../pages/Hall/components/HallSeating/components/GridSeats/helpers'
import Seat from '../../../Seat/Seat'
import Typography from '../../../Typography/Typography'

import './BasketItem.scss'

const BasketItem = ({ data, selectedSeats }) => {
    const seatType = getSeatType(data)

    const isGroupSeat = data?.group_seatid > 0
    const groupSeat = selectedSeats?.find((s) => s?.group_seatid === data?.group_seatid && s?.seatid !== data?.seatid)
    const isLeftGroupSeat = data?.seat < groupSeat?.seat
    const showSeatType = seatType !== SEAT_TYPES.CLASSIC || isGroupSeat

    if (isGroupSeat && !isLeftGroupSeat) return null

    return (
        <div className={'basket-item'}>
            {showSeatType && <Seat disabled type={seatType} size={data?.group_seatid > 0 ? 'double' : 'single'} />}
            <Typography variant={'bodyBold'} color={'basePrimary'}>
                {`${data?.row}${data?.seat}`}
                {isLeftGroupSeat && isGroupSeat && `+${groupSeat?.seat}`}
            </Typography>
        </div>
    )
}

export default BasketItem
